export const DATE_FORMATS = {
  YEAR: 'year',
  MONTH: 'month',
  YEAR_FORMAT: 'YYYY',
  MONTH_FORMAT: 'MMMM',
};
